<form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="p-fluid p-formgrid p-grid">
    <ng-container *ngFor="let controls of fields">
      <ng-container [ngSwitch]="controls.type">
        <!-- field start input-->
        <ng-container *ngSwitchDefault>
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <input
              [type]="controls.type"
              [formControlName]="controls.name"
              [placeholder]="controls.placeholder"
              pInputText
            />
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!-- end input field-->
        <!--start select field-->
        <ng-container *ngSwitchCase="'select'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <p-dropdown
              [options]="controls.source"
              [formControlName]="controls.name"
              [placeholder]="controls.placeholder"
              optionLabel="text"
              [showClear]="true"
              [filter]="true"
            ></p-dropdown>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!--end select field-->
        <!--start select field-->
        <ng-container *ngSwitchCase="'childselect'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <p-dropdown
              [options]="getSelectSource(controls)"
              [formControlName]="controls.name"
              [placeholder]="controls.placeholder"
              optionLabel="text"
              [showClear]="true"
              [filter]="true"
            ></p-dropdown>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!--end select field-->

        <!-- start of checkbox-->
        <ng-container *ngSwitchCase="'checkbox'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <div class="p-field-checkbox">
              <p-checkbox
                [formControlName]="controls.name"
                [value]="controls.source.value"
              ></p-checkbox>
              <label [for]="">{{ controls.source.text }}</label>
            </div>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!--end of checkbox-->

        <!-- start of multicheckbox field-->
        <ng-container *ngSwitchCase="'multicheckbox'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <div class="p-field-checkbox" *ngFor="let list of controls.source">
              <p-checkbox
                [formControl]="dynamicForm.controls[controls.name]"
                [value]="list"
                [inputId]="list.value"
              ></p-checkbox>
              <label [for]="list.value">{{ list.text }}</label>
            </div>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!-- end of multicheckbox field -->

        <!-- start of radio button -->
        <ng-container *ngSwitchCase="'radio'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>

            <!-- <p-radioButton *ngFor="let list of controls.source" [name]="controls.name" [label]="list.text"
      [value]="list.value" [formControlName]="controls.name" >
    </p-radioButton> -->
            <p-radioButton
              name="groupname"
              value="ps1"
              formControlName="radioselection"
            ></p-radioButton>
            <p-radioButton
              name="groupname"
              value="ps2"
              formControlName="radioselection"
            ></p-radioButton>
            <p-radioButton
              name="groupname"
              value="ps3"
              formControlName="radioselection"
            ></p-radioButton>
            <p-radioButton
              name="groupname"
              value="ps4"
              formControlName="radioselection"
            ></p-radioButton>

            <!-- <p-radioButton name="groupname" value="ps1" [formControlName]="controls.name"></p-radioButton>
    <p-radioButton name="groupname" value="ps2" [formControlName]="controls.name"></p-radioButton>
    <p-radioButton name="groupname" value="ps3" [formControlName]="controls.name"></p-radioButton>
    <p-radioButton name="groupname" value="ps4" [formControlName]="controls.name"></p-radioButton> -->

            <!-- <div class="p-field-radiobutton" *ngFor="let list of controls.source">
        <p-radioButton [formControlName]="controls.name"  [value]="list.text" ></p-radioButton>

      </div> -->
          </div>
        </ng-container>
        <!-- end of radio button-->

        <!-- start of textarea -->
        <ng-container *ngSwitchCase="'textarea'">
          <div class="p-field p-col-12 p-md-12">
            <label for="fieldId">{{ controls.label }}</label>
            <textarea
              [formControlName]="controls.name"
              pInputTextarea
              [rows]="controls.ui.rows"
              [cols]="controls.ui.cols"
            ></textarea>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!-- end of text area-->

        <!-- start of multiselect -->
        <ng-container *ngSwitchCase="'multiselect'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <p-multiSelect
              [options]="controls.source"
              [defaultLabel]="controls.placeholder"
              [formControlName]="controls.name"
              optionLabel="label"
            ></p-multiSelect>
            <ng-container *ngFor="let validation of controls.validations">
              <small
                class="p-invalid"
                *ngIf="
                  dynamicForm.controls[controls.name].touched &&
                  dynamicForm.controls[controls.name].errors
                "
              >
                <p
                  *ngIf="
                    dynamicForm.controls[controls.name].errors[validation.name]
                  "
                >
                  {{ validation.message }}
                </p>
              </small>
            </ng-container>
          </div>
        </ng-container>
        <!-- end of multiselect -->

        <!-- start of color -->
        <ng-container *ngSwitchCase="'color'">
          <div class="p-field p-col-12 p-md-6">
            <label for="fieldId">{{ controls.label }}</label>
            <p-colorPicker></p-colorPicker>
          </div>
        </ng-container>
        <!-- end of color -->
      </ng-container>
    </ng-container>
  </div>

  <button
    pButton
    type="submit"
    label="Submit"
    [disabled]="!dynamicForm.valid"
  ></button>
  <!-- <input type="submit" /> -->
</form>
